import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Header, Container, GridColumn, Grid } from "semantic-ui-react";
import QuadrantNavigation from "../../components/QuadrantNavigation";
import {
	LeftColumnText,
	RightColumnText,
	FirstSection,
	WhoShouldUseIt,
	HowToUseIt
} from "./Data";
import Markdown from "../../components/WrappedMarkdown";

export type RouteParams = null;
export interface OwnProps extends RouteComponentProps<RouteParams> {
	a: string;
}

export interface State {}

class LandingPage extends React.Component<OwnProps, State> {
	state = {};

	render() {
		return (
			<Container>
				<Header size="huge" textAlign="center">
					About the Small Business Framework
				</Header>
				<Container text style={{ margin: "12px 0" }}>
					<Markdown source={FirstSection} />
					<QuadrantNavigation />
				</Container>
				<Container text style={{ margin: "12px 0" }}>
					<Markdown source={WhoShouldUseIt} />
				</Container>
				<Container text style={{ margin: "12px 0" }}>
					<img
						src={require("./HowTo.png")}
						style={{
							float: "right",
							margin: 12
						}}
					/>
					<Markdown
						source={HowToUseIt}
						renderers={{ root: React.Fragment }}
					/>
					<p>
						Each quadrant contains icons. Refer right for an
						explanation of each icon:
					</p>
					<img
						src={require("./ComponentInstruction.png")}
						style={{ clear: "inline-end" }}
					/>
				</Container>
				{/* <Container text>
					<p>
						Each quadrant contains icons. Refer right for an
						explanation of each icon:
					</p>
				</Container> */}
				{/* <Grid columns={2}>
					<GridColumn />
					<GridColumn>
						<Markdown source={RightColumnText} />
					</GridColumn>
				</Grid> */}
			</Container>
		);
	}
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingPage.tsx